import React, {useContext, useState} from "react";
// Use Forms
import {useForm} from "react-hook-form";
import {ErrorMessage} from "@hookform/error-message";
// React Bootstrap
import {Accordion, Button, Card, Col, Container, Form} from "react-bootstrap";
// Contexto
import {context, tipoMisiones, tiposEnColaboracion, tiposObras, tiposProyectos} from "../../../../contexto";
import {AlertBoxContext} from "../../../../context/alertBoxContext";
// jquery
import $ from "jquery";
// Utils
import {dateToString2, removeEmptyFields} from "../../../../utils";
// Router
import {useHistory} from "react-router-dom";
// Componentes
import CustomSpinner from "../../../generic/CustomSpinner";

const FormNuevaMision = ({...props}) => {
  // TODO quitar esto ponerlo en el root
  const idProvincia = props.computedMatch.params.id_p;

  // Pusheamiento de la ruta
  let history = useHistory();
  // Validación del formulario
  const [validated] = useState(false);
  // Valores por defecto del formulario (esto debería pasarse del padre)
  const defaultValues = {type: "Obra", startDate: dateToString2(new Date())};
  // Spinner
  const [loading, setLoading] = useState(false);
  // Alertas
  const {addAlert} = useContext(AlertBoxContext);
  // Hook forms
  const {
    register,
    handleSubmit,
    watch,
    formState: {errors},
  } = useForm({defaultValues: defaultValues});

  // Petición para añadir una misión
  const postMision = (data) => {
    let settings = {
      url: process.env.REACT_APP_API_URL + "/provincias/" + idProvincia + "/misiones",
      method: "POST",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      data: data,
    };
    return $.ajax(settings);
  };

  // Manejador para la función de añadir misión
  const handlePostMision = (data) => {
    setLoading(true);
    removeEmptyFields(data);
    postMision(data)
      .then((response) => {
        setLoading(false);
        history.push("/provincias/" + response.provinceId + "/mision/" + response.id);
        addAlert("Exito", "Se ha añadido la misión correctamente", "success");
      })
      .catch(() => {
        setLoading(false);
        props?.ErrorHandling();
      });
  };

  // On submit del formulario
  const onSubmit = (data) => {
    handlePostMision(data);
  };

  return (
    <Container {...props} style={{ position: "relative" }}>
      <CustomSpinner animation={"border"} loading={loading} />
      <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="m-3">
        <Form.Row>
          <small className="mb-3">
            Los campos con un <b>*</b> deben de ser rellenados.
          </small>
        </Form.Row>
        <Accordion defaultActiveKey="0" className="mb-2">
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="0">
              Información principal
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                <Form.Row>
                  <Form.Group as={Col} xs={12} md controlId="name-add-new-mission">
                    <Form.Label>{"Nombre de la misión *"}</Form.Label>
                    <Form.Control
                      name="name"
                      placeholder={"Texto"}
                      type="text"
                      isInvalid={errors?.name}
                      {...register("name", {
                        required: "Este campo es obligatorio",
                        maxLength: {
                          value: 80,
                          message: "El máximo de caracteres es 80",
                        },
                      })}
                    />
                    <ErrorMessage errors={errors} name="name" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>
                  <Form.Group as={Col} xs={12} md controlId="key-add-new-mission">
                    <Form.Label>{"Clave"}</Form.Label>
                    <Form.Control
                      name="key"
                      placeholder={"Texto"}
                      type="text"
                      isInvalid={errors?.key}
                      {...register("key", {
                        maxLength: {
                          value: 80,
                          message: "El máximo de caracteres es 80",
                        },
                      })}
                    />
                    <ErrorMessage errors={errors} name="key" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>
                </Form.Row>

                <Form.Row>
                  <Form.Group as={Col} xs={12} md controlId="" className="pt-md-4">
                    <Form.Check custom id="isCollaborative" label={"¿Es una misión en colaboración?"} name="isCollaborative" {...register("isCollaborative", {})} />
                  </Form.Group>
                  <Form.Group as={Col} xs={12} md controlId="type-add-new-mission">
                    <Form.Label>{"Tipo"}</Form.Label>
                    <Form.Control name="type" as="select" custom isInvalid={errors.type} {...register("type", { required: "Este campo es obligatorio" })}>
                      {Object.keys(tipoMisiones).length
                        ? Object.keys(tipoMisiones).map((keyType) => (
                          <option key={keyType} value={keyType}>
                            {tipoMisiones[keyType]}{!watch("isCollaborative") && " STJ"}
                          </option>
                        ))
                        : ""}
                    </Form.Control>
                    <ErrorMessage errors={errors} name="type" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>

                  {tiposObras && tiposProyectos && tiposEnColaboracion && (
                    <Form.Group as={Col} xs={12} md controlId="category-add-new-mission">
                      <Form.Label>{"Categoría *"}</Form.Label>
                      <Form.Control name="category" as="select" custom isInvalid={errors.type} {...register("category", { required: "Este campo es obligatorio" })}>
                      <option value="">
                              - Seleccione una categoría -
                            </option>
                        {watch("type") === "Obra" &&
                          Object.keys(tiposObras).map((keyCategoria) => (
                            
                            <option key={keyCategoria} value={keyCategoria}>
                              {tiposObras[keyCategoria]}
                            </option>
                          ))}
                        {watch("type") === "Proyecto" &&
                          Object.keys(tiposProyectos).map((keyCategoria) => (
                            <option key={keyCategoria} value={keyCategoria}>
                              {tiposProyectos[keyCategoria]}
                            </option>
                          ))}

                        {watch("isCollaborative") === true &&
                          watch("type") === "Obra" &&
                          Object.keys(tiposEnColaboracion).map((keyCategoria) => (
                            <option key={keyCategoria} value={keyCategoria}>
                              {tiposEnColaboracion[keyCategoria]}
                            </option>
                          ))}
                      </Form.Control>
                      <ErrorMessage errors={errors} name="category" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                    </Form.Group>
                  )}
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} xs={12} md controlId="contextId-add-new-mission">
                    <Form.Label>{"Contexto"}</Form.Label>
                    <Form.Control name="contextId" as="select" custom isInvalid={errors.contextId} {...register("contextId", { required: "Este campo es obligatorio" })}>
                      {Object.keys(context).map((contextKey, index) => (
                        <option key={index} value={contextKey}>
                          {context[contextKey]}
                        </option>
                      ))}
                    </Form.Control>
                    <ErrorMessage errors={errors} name="contextId" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>
                  <Form.Group as={Col} xs={12} md controlId="description-mission">
                    <Form.Label>{"Descripción"}</Form.Label>
                    <Form.Control
                      name="description"
                      as="textarea"
                      placeholder={"Descripción"}
                      type="text"
                      isInvalid={errors?.description}
                      {...register("description", {
                        maxLength: {
                          value: 500,
                          message: "El máximo de caracteres es 500",
                        },
                      })}
                    />
                    <ErrorMessage errors={errors} name="description" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>
                </Form.Row>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>

        <Accordion defaultActiveKey="0" className="mb-3">
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="0">
              Dirección
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                <Form.Row>
                  <Form.Group as={Col} xs={12} md controlId="country-add-new-mission">
                    <Form.Label>{"País"}</Form.Label>
                    <Form.Control
                      name="country"
                      placeholder={"Texto"}
                      type="text"
                      isInvalid={errors?.country}
                      {...register("country", {
                        maxLength: {
                          value: 60,
                          message: "El máximo de caracteres es 60",
                        },
                      })}
                    />
                    <ErrorMessage errors={errors} name="country" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>

                  <Form.Group as={Col} xs={12} md controlId="provinceAddress-add-new-mission">
                    <Form.Label>{"Provincia-Estado"}</Form.Label>
                    <Form.Control
                      name="provinceAddress"
                      placeholder={"Texto"}
                      type="text"
                      isInvalid={errors?.country}
                      {...register("provinceAddress", {
                        maxLength: {
                          value: 70,
                          message: "El máximo de caracteres es 70",
                        },
                      })}
                    />
                    <ErrorMessage errors={errors} name="provinceAddress" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>

                  <Form.Group as={Col} xs={12} md controlId="postcode-add-new-mission">
                    <Form.Label>{"Código postal"}</Form.Label>
                    <Form.Control
                      name="postcode"
                      placeholder={"Texto"}
                      type="text"
                      isInvalid={errors?.postcode}
                      {...register("postcode", {
                        maxLength: {
                          value: 15,
                          message: "El máximo de caracteres es 15",
                        },
                      })}
                    />
                    <ErrorMessage errors={errors} name="postcode" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} xs={12} md controlId="place-add-new-mission">
                    <Form.Label>{"Localidad"}</Form.Label>
                    <Form.Control
                      name="place"
                      placeholder={"Texto"}
                      type="text"
                      isInvalid={errors?.place}
                      {...register("place", {
                        maxLength: {
                          value: 60,
                          message: "El máximo de caracteres es 60",
                        },
                      })}
                    />
                    <ErrorMessage errors={errors} name="place" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>

                  <Form.Group as={Col} xs={12} md controlId="address-add-new-mission">
                    <Form.Label>{"Calle"}</Form.Label>
                    <Form.Control
                      name="address"
                      placeholder={"Texto"}
                      type="text"
                      isInvalid={errors?.address}
                      {...register("address", {
                        maxLength: {
                          value: 150,
                          message: "El máximo de caracteres es 150",
                        },
                      })}
                    />
                    <ErrorMessage errors={errors} name="address" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>
                </Form.Row>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>

        <Accordion defaultActiveKey="0" className="mb-2">
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="0">
              Estado
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                <Form.Row>
                  <Form.Group as={Col} xs={12} md controlId="activity-start-mission">
                    <Form.Label>{"Fecha de apertura"}</Form.Label>
                    <Form.Control
                      name="startDate"
                      type="date"
                      isInvalid={errors?.startDate}
                      {...register("startDate", {
                        validate: (date) => {
                          return new Date(date) >= new Date() ? "La fecha no debe ser mayor a hoy" : true;
                        },
                      })}
                    />
                    <ErrorMessage errors={errors} name="startDate" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>

                  <Form.Group as={Col} xs={12} md controlId="activity-end-mission">
                    <Form.Label>{"Fecha de cierre"}</Form.Label>
                    <Form.Control name="endDate" type="date" isInvalid={errors?.endDate} {...register("endDate", {})} />
                    <ErrorMessage errors={errors} name="endDate" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>
                </Form.Row>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>

        <Accordion defaultActiveKey="0" className="mb-2">
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="0">
              Calendario actividades
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                <Form.Row>
                  <Form.Group as={Col} xs={12} md controlId="start-date-mission">
                    <Form.Label>{"Fecha Inicial"}</Form.Label>
                    <Form.Control name="activityStart" type="date" isInvalid={errors?.activityStart} {...register("activityStart", {})} />
                    <ErrorMessage errors={errors} name="activityStart" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>

                  <Form.Group as={Col} xs={12} md controlId="end-date-mission">
                    <Form.Label>{"Fecha Final"}</Form.Label>
                    <Form.Control name="activityEnd" type="date" isInvalid={errors?.activityEnd} {...register("activityEnd", {})} />
                    <ErrorMessage errors={errors} name="activityEnd" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>
                </Form.Row>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>

        <Accordion defaultActiveKey="0" className="mb-2">
          <Card>
            <Accordion.Toggle as={Card.Header} eventKey="0">
              Datos contacto
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                <Form.Row>
                  <Form.Group as={Col} xs={12} md controlId="telephone-add-new-mission">
                    <Form.Label>{"Teléfono"}</Form.Label>
                    <Form.Control
                      name="telephone"
                      placeholder={"Number"}
                      type="text"
                      isInvalid={errors?.key}
                      {...register("telephone", {
                        maxLength: {
                          value: 25,
                          message: "El máximo de caracteres es 25",
                        },
                      })}
                    />
                    <ErrorMessage errors={errors} name="telephone" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>
                  <Form.Group as={Col} xs={12} md controlId="email-mission">
                    <Form.Label>{"Email"}</Form.Label>
                    <Form.Control
                      name="email"
                      placeholder={"Texto"}
                      type="text"
                      isInvalid={errors?.email}
                      {...register("email", {
                        maxLength: {
                          value: 320,
                          message: "El máximo de caracteres es 320",
                        },
                        pattern: {
                          value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                          message: "El campo debe ser un email",
                        },
                      })}
                    />
                    <ErrorMessage errors={errors} name="email" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>
                </Form.Row>

                <Form.Row>
                  <Form.Group as={Col} xs={12} md controlId="web-add-new-mission">
                    <Form.Label>{"Web"}</Form.Label>
                    <Form.Control
                      name="web"
                      placeholder={"Texto"}
                      type="text"
                      isInvalid={errors?.web}
                      {...register("web", {
                        maxLength: {
                          value: 200,
                          message: "El máximo de caracteres es 200",
                        },
                      })}
                    />
                    <ErrorMessage errors={errors} name="web" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>

                  <Form.Group as={Col} xs={12} md controlId="rrss-add-new-mission">
                    <Form.Label>{"RRSS"}</Form.Label>
                    <Form.Control
                      name="RRSS"
                      placeholder={"Texto"}
                      type="text"
                      as={"textarea"}
                      isInvalid={errors?.RRSS}
                      {...register("RRSS", {
                        maxLength: {
                          value: 100,
                          message: "El máximo de caracteres es 100",
                        },
                      })}
                    />
                    <ErrorMessage errors={errors} name="RRSS" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
                  </Form.Group>
                </Form.Row>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>

        <Button variant="outline-primary" type="submit" className={"w-100"}>
          {"Añadir misión"}
        </Button>
      </Form>
    </Container>
  );
};

export default FormNuevaMision;
